export const AUTH_TOKEN = 'auth_token'
export const ATTRIBUTION_COOKIE = 'attribution'